/* Paths for APIs */
export const CATEGORIES = 'categories'
export const CHARACTERS = 'characters'
export const CONTACT_US = 'contact-us'
export const DICTIONARY = 'dictionary'
export const EXPORT_JOBS = 'export-jobs'
export const GALLERIES = 'galleries'
export const IMMERSION_LABELS = 'immersion-labels'
export const IMPORT_JOBS = 'import-jobs'
export const JOIN_REQUESTS = 'join-requests'
export const LANGUAGES = 'languages'
export const MEMBERSHIPS = 'memberships'
export const MY_SITES = 'my-sites'
export const PAGES = 'pages'
export const PARTS_OF_SPEECH = 'parts-of-speech'
export const PEOPLE = 'people'
export const SEARCH = 'search'
export const SITES = 'sites'
export const SONGS = 'songs'
export const STATS = 'stats'
export const STORIES = 'stories'
export const STORY_PAGES = 'pages'
export const WIDGETS = 'widgets'
export const WORD_OF_THE_DAY = 'word-of-the-day'

// MEDIA
export const AUDIO_PATH = 'audio'
export const DOCUMENT_PATH = 'documents'
export const IMAGE_PATH = 'images'
export const VIDEO_PATH = 'videos'

// GAMES
export const WORDSY = 'wordsy'

// FRONTEND ONLY PATHS
export const PHRASES = 'phrases'
export const WORDS = 'words'
export const MEDIA = 'media'
export const SHARED_IMAGES_PATH = 'shared-images'
